export default {
  '/': [{ displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' }, { displayName: 'Mesa de Regalos', route: '/' }],
  'createEvent/SelectMesaType': [{ displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' }, { displayName: 'Mesa de Regalos', route: '/' }],
  '/createEvent/Celebrations': [{ displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' }, { displayName: 'Mesa de Regalos', route: '/' }],
  createAccount: [{ displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' }, { displayName: 'Mesa de Regalos', route: '/' }],
  'EventDetails/page/Celebrations': [{ displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' }, { displayName: 'Mesa de Regalos', route: '/' }, { displayName: 'Celebrations', route: '' }],
  '/eventManagement': [
    { displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' },
    { displayName: 'Mesa de Regalos', route: '/' },
    { displayName: 'EventManagement', route: '/eventManagement/GiftList' },
    {
      DatosDeMiEvento: { displayName: 'DatosDeMiEvento', route: '' },
      Contrato: { displayName: 'Contrato', route: '' },
      RegaloPorCierre: { displayName: 'RegaloPorCierre', route: '' },
      MisMonederos: { displayName: 'MisMonederos', route: '' },
      GiftOpening: { displayName: 'GiftOpening', route: '' },
      GiftPreferences: { displayName: 'GiftPreferences', route: '' },
    },
  ],
  GiftList: [{ displayName: 'Home', route: 'http://st.liverpool.com.mx/tienda' }, { displayName: 'Mesa de Regalos', route: '/' }, { displayName: 'GiftList', route: '' }],
};
